import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { GridColumns } from './GridColumns';


class NotificationNew extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : GridColumns,
        CRUDServices:{
          Create:apiDashBoardService.createNotification,
          Update:apiDashBoardService.updateNotification,
          Delete:apiDashBoardService.deleteNotificationById}
      };
    }
    refreshList(){
      apiDashBoardService.getNotifications()
      .then((response) => {
        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false,recordStatus:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Bildirim bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getNotifications exception: ' + JSON.stringify(exception));
      });      
    }
    componentDidMount() {
      this.refreshList();
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <BasicPageComponent
              title='BİLDİRİM AYARLARI'
              description='Bildirim Tanımlama Ekranı'
              children = {
                <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Bildirim" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
              </ScreenContainer>
              }
            />       
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(NotificationNew);